module.exports = __webpack_public_path__ + "static/media/Agri-Retailers Infographic Desktop - GBR care -  16-05-2024 N.2d107443.gif";